import { SafeHtml } from '@angular/platform-browser';

export interface DynamicObject {
  [key: string]: any
}

export enum AlertType {
  Success,
  Error,
  Info,
  Warning
}
export class Alert {
  type!: AlertType;
  message!: string | SafeHtml;
  // optional per-alert auto-dismiss duration in ms; when unset the AlertComponent uses its type-based default
  duration?: number;
}
export interface Insights {
  name: string
  series: Series[]
}
export interface Series {
  value: number
  name: string
  month: string
}

export interface Status {
  name: string
  value: number
}
